import firebase from 'firebase';
import { AppDispatch } from '../../store';
import {
  sessionUpdated, sessionListenerError,
  sessionMenuItemUpdated, resetSessionMenuItem, resetSession,
} from './session.slice';
import { COLLECTIONS } from '../../constants/data';
import { serializeSessionMenuItemModelSnap, serializeSessionModelSnap } from './session.service';

let unsubscribeSession: firebase.Unsubscribe | null = null;
let unsubscribeSessionMenuItems: firebase.Unsubscribe | null = null;
let activeSessionKey: string | null = null; // "restaurantId::sessionId"

const makeKey = (restaurantId: string, sessionId: string) => `${restaurantId}::${sessionId}`;

export const syncSessionListeners = (
  restaurantId: string | null,
  sessionId: string | null,
  dispatch: AppDispatch
) => {
  const key = restaurantId && sessionId ? makeKey(restaurantId, sessionId) : null;
  if (key === activeSessionKey) return;

  if (unsubscribeSession) { unsubscribeSession(); unsubscribeSession = null; }
  if (unsubscribeSessionMenuItems) { unsubscribeSessionMenuItems(); unsubscribeSessionMenuItems = null; }

  activeSessionKey = key;

  if (!key || !restaurantId || !sessionId) {
    dispatch(resetSession());
    dispatch(resetSessionMenuItem());
    return;
  }

  const sessionRef = firebase.firestore()
    .collection(COLLECTIONS.restaurants).doc(restaurantId)
    .collection(COLLECTIONS.dineInTableSitting).doc(sessionId);

  unsubscribeSession = sessionRef.onSnapshot(
    (snapshot) => {
      if (!snapshot.exists) return;
      dispatch(sessionUpdated(serializeSessionModelSnap(snapshot)));
    },
    (error) => {
      dispatch(sessionListenerError(error.message));
      activeSessionKey = null;
      unsubscribeSession = null;
    }
  );

  unsubscribeSessionMenuItems = sessionRef
    .collection(COLLECTIONS.menuItems)
    .onSnapshot(
      (snapshot) => {
        dispatch(sessionMenuItemUpdated(snapshot.docs.map(serializeSessionMenuItemModelSnap)));
      },
      (error) => {
        dispatch(sessionListenerError(error.message));
        unsubscribeSessionMenuItems = null;
      }
    );
};